<script>
const ASSETS_PER_ROW = 4;
import { mapActions, mapState } from 'vuex';

export default {
   data() {
      return {
         audioPlayingIndex: -1 //keep track of which audio asset is playing
      }
   }, 

   props: {
      channelRecid: String | Number,
      isScoreboard: Boolean,
      activeAssetId: Number | String
   },

   computed: {
      ...mapState('global', [
         'currSearchTerm',
         'currSelectedCategory',
         'currSelectedAssetType',
      ]),

      rowCount() {     
         return Math.ceil(this.assets.length / ASSETS_PER_ROW);
      }
   },

   methods: {
      assetCountInRow:function(index){
         return this.assets.slice((index - 1) * ASSETS_PER_ROW, index * ASSETS_PER_ROW);
      },

      getAssets() {
         //implemented by children
      },

      showMore() {
         this.page += 20;
         this.getAssets();
      },

      handlePlay(index) {
         if (this.audioPlayingIndex != -1) {
            let playing = document.querySelectorAll('.audio')[this.audioPlayingIndex];
            playing.pause();
            playing.currentTime = 0;
         }
         const mediaElem = document.querySelectorAll('.audio')[index];
         this.audioPlayingIndex = index;
         mediaElem.play();
      },

      handlePause(index) {
         const mediaElem = document.querySelectorAll('.audio')[index];
         this.audioPlayingIndex = -1;
         mediaElem.pause();
         mediaElem.currentTime = 0;
      }
   },

   created() {
      this.getAssets();
   },

   watch: {
      // mpAssetType: function() {
      //    this.assets = [];
      //    this.page = 0;
      //    this.moreToShow = true;
      //    this.audioPlayingIndex = -1;
      //    this.getAssets();
      // },

      currSelectedAssetType() {
         this.getAssets(true);
      },

      currSearchTerm() {
         this.getAssets(true);
      }, 

      currSelectedCategory() {
         this.getAssets(true);
      }
   }
}
</script>

<style lang="scss" scoped>
.asset-wrapper {
   padding: 15px 0;
   border-top: 1px solid white;
}

.asset-row {
   display: flex;
   flex-wrap: wrap;

   &:not(:last-child) {
      margin-bottom: 8px;
   }
}

.show-more-container {
   text-align: center;
   margin-top: 20px;

   &:hover {
      cursor: pointer;

      .show-more-text {
         color: #a7a7a7;
         text-transform: uppercase;
      }
   }
}

.show-more-text {
   color: #585858;
   text-transform: uppercase;
   font-size: 14px;
}

#recent_assets {
   padding-right: 25px;
}

.no-assets {
   color: #cacaca;
   text-align: center;
}

</style>
